import { createContext, useContext, useEffect, useState } from 'react';
import { Merchant } from '@bringg/types';

import { useAuth } from './Auth';

export const MerchantContext = createContext({} as any);

export function MerchantProvider({ children }: any) {
  const { dashboardSdk, isLoggedIn } = useAuth();

  const [merchant, setMerchant] = useState<Merchant | null>(null);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    async function fetchMerchant() {
      setMerchant(await dashboardSdk.sdk.merchant.get());
    }

    fetchMerchant();
  }, [isLoggedIn, dashboardSdk]);

  return <MerchantContext.Provider value={merchant}>{children}</MerchantContext.Provider>;
}

export const useMerchant = () => useContext(MerchantContext);
